module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp12_8017.efa2da73.png";